import { Record } from 'immutable';

export default class TimeplanPeriod extends Record({
  customerFee: null,
  resourceFee: null,
  resourceCost: null,
  resourceCostSettled: null,
  profit: null,
  profitPercentage: null,
  daysCount: null,
  minutes: null,
  from: null,
  fromDate: null,
  to: null,
  toDate: null,
  timeplanUnits: null,
  expenseCost: null,
  cost: null,
  mileageAllowancesResourceCost: undefined,
}) {
}
